import axiosInstance from './axiosInstance';
import type { Response } from './axiosInstance';

export interface CopyConfig {
  id: number;
  key: string;
  type: string;
  zh: string;
  en: string;
  created_at: string;
  updated_at: string;
}

export const getAllCopyConfigs = async (type?: string): Promise<CopyConfig[]> => {
  try {
    const params = type ? { type } : {};
    const response = await axiosInstance.get<Response<CopyConfig[]>>('/copy-config', { params });
    return response.data?.data ?? [];
  } catch (e) {
    console.error('Failed to fetch copy configs', e);
    return [];
  }
};

export const getCopyConfigByKey = async (key: string): Promise<CopyConfig | null> => {
  try {
    const response = await axiosInstance.get<Response<CopyConfig>>('/copy-config/by-key', {
      params: { key },
    });
    return response.data?.data ?? null;
  } catch (e) {
    console.error(`Failed to fetch copy config for key: ${key}`, e);
    return null;
  }
};
